import { useEffect, useState } from "react";
import { TChartData } from "src/app/components/Chart/Chart";
import { StatsSiteTranporter } from "src/app/transports/statsSites";
import { TStats } from "src/app/types/statsSite";

const useSiteStatChart = (seletedStat: TStats, siteId?: number) => {
    const [siteStatsChart, setSiteStatsChart] = useState<TChartData>();
    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState(true);

    const fetch = () => {
        if (!siteId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        StatsSiteTranporter.list(seletedStat, siteId)
            .then((res) => {
                const stats: TChartData = {};
                res.forEach((stat) => (stats[stat.date] = stat.statValue));
                setSiteStatsChart(stats);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        fetch();
    }, [siteId]);

    return { siteStatsChart, loading, error, refresh };
};

export default useSiteStatChart;
